import { catalogMessages } from './messages-catalog';
import { customerMessages } from './messages-customer';
import { craftMessages } from './messages-craft';
import { ownerMessages } from './messages-owners';
import { publicMessages } from './messages-public';
import { storefrontFixMessages } from './messages-storefront-fixes';

export type StorefrontLanguage = 'en' | 'fr' | 'ar';
export type TranslationValues = Record<string, string | number>;

const translations: Record<Exclude<StorefrontLanguage, 'en'>, Record<string, string>> = {
  fr: {
    ...publicMessages.fr,
    ...catalogMessages.fr,
    ...customerMessages.fr,
    ...storefrontFixMessages.fr,
    ...craftMessages.fr,
    ...ownerMessages.fr,
  },
  ar: {
    ...publicMessages.ar,
    ...catalogMessages.ar,
    ...customerMessages.ar,
    ...storefrontFixMessages.ar,
    ...craftMessages.ar,
    ...ownerMessages.ar,
  },
};

const obsoleteProductTranslationNotices = new Set([
  "We couldn't verify whether product translations are published. Some product information may remain in English.",
  'Product translations for this language are not published in the store yet. Product names and descriptions are shown in English.',
]);

export function translateMessage(
  language: StorefrontLanguage,
  message: string,
  values?: TranslationValues,
) {
  if (obsoleteProductTranslationNotices.has(message)) return '';

  const translated =
    language === 'en' ? message : (translations[language][message] ?? message);

  if (!values) return translated;
  return translated.replace(/\{(\w+)\}/g, (placeholder, key: string) =>
    key in values ? String(values[key]) : placeholder,
  );
}

export const storefrontLanguages: Array<{
  code: StorefrontLanguage;
  label: string;
}> = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'ar', label: 'العربية' },
];